// @ts-nocheck
import * as React from "react";

const Receipt: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M6 20.808a1.933 1.933 0 0 1-1.423-.577A1.922 1.922 0 0 1 4 18.817v-2.009h3V3.192l1.269.885 1.308-.885 1.307.885 1.308-.885 1.308.885 1.308-.885 1.308.885 1.308-.885 1.308.885 1.269-.885v15.616c0 .564-.192 1.038-.577 1.423a1.933 1.933 0 0 1-1.423.577H6Zm12-1a.965.965 0 0 0 .712-.288.967.967 0 0 0 .288-.712v-14H8v12h9v2c0 .283.096.521.288.712a.967.967 0 0 0 .712.288Zm-8.616-11.5v-1h5.346v1H9.384Zm0 3v-1h5.346v1H9.384Zm7.501-2.731a.739.739 0 0 1-.539-.23c-.153-.153-.23-.333-.23-.54s.077-.386.23-.539c.153-.153.333-.23.539-.23s.386.077.539.23c.153.153.23.333.23.539s-.077.386-.23.54a.739.739 0 0 1-.539.23Zm0 3a.739.739 0 0 1-.539-.23c-.153-.153-.23-.333-.23-.539s.077-.386.23-.54c.153-.153.333-.23.539-.23s.386.077.539.23c.153.153.23.333.23.54s-.077.386-.23.539a.739.739 0 0 1-.539.23ZM6 19.808h10v-2H5v1c0 .283.096.521.287.712a.967.967 0 0 0 .713.288Z"
            />
        </svg>
    );
};

export default React.memo(Receipt);
